import { cn } from "@/utils/theme";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-testid="skeleton"
      data-slot="skeleton"
      className={cn(
        "bg-neutral-object-accent-quiet animate-pulse rounded-md",
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
